import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const gpstabConfig: TSPConfig = {
  key: 'gpstab',
  name: 'GPSTab',
  category: TSPCategory.API_KEY,
  helpText: 'Request an API key from your GPSTab representative.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default gpstabConfig;
